<div class="np-layout">
  <!-- Header bar -->
  <div class="np-header">
    <span class="np-header-title">Uniformax</span>
    <div class="np-header-actions">
      <span class="np-user-badge">{{ userInitials }}</span>
      <button pButton type="button" class="p-button-text p-button-sm" title="Printer settings" (click)="openPrinterSettings()">
        <i class="pi pi-cog"></i>
      </button>
      <button pButton type="button" class="p-button-text p-button-sm" title="Logout" (click)="logout()">
        <i class="pi pi-sign-out"></i>
      </button>
    </div>
  </div>

  <!-- Content area -->
  <div class="np-content">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Notepad-mode equivalent of uni-page's confirm dialog. Required so
     askYesNo() / confirmCancel() resolve instead of hanging silently
     (notepad has no <app-uni-page> wrapper to provide one). -->
<p-confirmDialog [closable]="false" [baseZIndex]="999"></p-confirmDialog>

